import {
    SIM_PROVIDER_DELETE_OPEN_MODAL,
    SIM_PROVIDER_DELETE_REQUEST,
    SIM_PROVIDER_DELETE_RESULT
} from 'Redux/actionTypes';

export const simProviderDeleteOpenModal = (open, data) => ({
    type: SIM_PROVIDER_DELETE_OPEN_MODAL,
    payload: { open, data }
})
export const simProviderDeleteRequest = (data) => ({
    type: SIM_PROVIDER_DELETE_REQUEST,
    payload: data
})
export const simProviderDeleteResult = (data) => ({
    type: SIM_PROVIDER_DELETE_RESULT,
    payload: data
})

